export function open() { return { type: 'SPOTLIGHT/OPEN' } }
export function close() { return { type: 'SPOTLIGHT/CLOSE' } }
export function search(args) { return { type: 'SPOTLIGHT/FETCH', args } }
export function clear() { return { type: 'SPOTLIGHT/CLEAR', } }